// extracted by mini-css-extract-plugin
export default {"Popper":"Popper--cOtIl","Popper__tooltip":"Popper__tooltip--yOO9k","Popper__arrow":"Popper__arrow--YlM9U"};